<template>
    <div>
        <div class="row mb-3 align-items-center">
            <div class="col-6">
                <h6 class="proxima-nova-bold">Upcoming Invoices</h6>
            </div>
            <div class="col-6">
                <button style="float: right" type="button" class="btn btn-primary" @click="onAddInvoice">
                    Add Draft
                </button>
                <dialog-window :show="dialog" @close="dialog = false">
                    <invoice-draft-form
                        v-if="currentInvoice"
                        :order="order"
                        :id="currentInvoice.id"
                        :invoice-date.sync="currentInvoice.invoice_date"
                        :invoice-period-start.sync="currentInvoice.invoice_period_start"
                        :invoice-period-end.sync="currentInvoice.invoice_period_end"
                        :rental-fee.sync="currentInvoice.rental_fee"
                        :rental-fee-comment.sync="currentInvoice.rental_fee_comment"
                        :ads-package.sync="currentInvoice.ads_package"
                        :ads-package-comment.sync="currentInvoice.ads_package_comment"
                        :discount.sync="currentInvoice.discount"
                        :is-skipped.sync="currentInvoice.is_skipped"
                        :loading="loading"
                        v-on:submit="onInvoiceSubmit"
                    />
                </dialog-window>
            </div>
        </div>
        <invoice-drafts-table
            :invoices="invoices"
            :organizations="organizations"
            :show-client="showClient"
            :show-order="showOrder"
            @edit-invoice="onEditInvoice"
        />
    </div>
</template>

<script>

import DialogWindow from './DialogWindow';
import InvoiceDraftForm from './InvoiceDraftForm';
import InvoiceDraftsTable from './InvoiceDraftsTable';

export default {
    name: 'invoice-drafts-new',
    components: { InvoiceDraftsTable, InvoiceDraftForm, DialogWindow },
    props: ['order', 'organizations', 'showClient', 'showOrder'],
    data: function () {
        return {
            invoices: [...this.order.invoice_drafts],
            currentInvoice: null,
            dialog: false,
            loading: false,
            dateFrom: null,
            dateTo: null,
        };
    },
    mounted() {
      this.fetchDates();
    },
    methods: {
        onAddInvoice() {
            this.currentInvoice = {
                id: 0,
                order_id: this.order.id,
                invoice_date: new Date(this.dateFrom),
                invoice_period_start: new Date(this.dateFrom),
                invoice_period_end: new Date(this.dateTo),
                rental_fee: 0,
                rental_fee_comment: '',
                ads_package: 0,
                ads_package_comment: '',
                discount: 0,
                is_skipped: false,
            };
            this.dialog = true;
        },
        onEditInvoice(invoice) {
            this.currentInvoice = JSON.parse(JSON.stringify(invoice));
            this.currentInvoice.invoice_date = new Date(this.currentInvoice.invoice_date);
            this.currentInvoice.invoice_period_start = new Date(this.currentInvoice.invoice_period_start);
            this.currentInvoice.invoice_period_end = new Date(this.currentInvoice.invoice_period_end);
            this.dialog = true;
        },
        onInvoiceSubmit() {
            this.loading = true;
            if (this.currentInvoice.id > 0) {
                this.$http.put(`/invoices/${this.currentInvoice.id}`, this.currentInvoice).then((res) => {
                    const idx = this.invoices.findIndex((x => x.id === res.data.id));
                    this.$set(this.invoices, idx, res.data);
                }).catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.dialog = false;
                    this.loading = false;
                });
            } else {
                this.$http.post(`/invoices/`, this.currentInvoice).then((res) => {
                    this.invoices.push(res.data);
                }).catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.dialog = false;
                    this.loading = false;
                });
            }
        },
        getVAT(order) {
            if (order.currency === 'SEK') {
                return 0.25;
            }
            if (order.currency === 'GBP') {
                return 0.20;
            }
            return NaN;
        },
        getTotal(invoice, skipVat) {
            const vat = skipVat && skipVat === true ? 0 : this.getVAT(invoice.order);
            const discount = invoice.discount / 100;
            const total = (1 + vat) * (invoice.rental_fee * (1 - discount) + invoice.ads_package * 1);
            return Math.round((total + Number.EPSILON) * 100) / 100;
        },
        fetchDates() {
            return new Promise((resolve, reject) => {
                axios.get('/client/dates/').then((res) => {
                    this.dateFrom = new Date(res.data.from);
                    this.dateTo = new Date(res.data.to);
                    resolve();
                }).catch(e => {
                    this.dateFrom = null;
                    this.dateTo = null;
                    console.log(e);
                    reject(e);
                });
            });
        },
    },
    filters: {
        formatDateYmd(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(date) {
            return moment(date).format('MMM Do HH:mm');
        }
    },
}
</script>
